import { Component, Inject, OnInit, Optional, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ModalModule } from '@core/components/modal/modal.module';
import { SharedModule } from '@shared/shared.module';
import { DateFnsModule } from 'ngx-date-fns';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslationModule } from '@core/translation/translation.module';

@Component({
    selector: 'berth-reservation-dialog',
    templateUrl: './berth-reservation-dialog.html',
    styleUrls: ['./berth-reservation-dialog.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    imports: [
        ModalModule,
        SharedModule,
        DateFnsModule,
        MatTooltipModule,
        TranslationModule,
    ]
})

export class BerthReservationsDialog implements OnInit {
    reservedAssignments: any[];

    constructor(
        public dialogRef: MatDialogRef<BerthReservationsDialog>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: {
            reservedAssignments: any[];
        },
    ) {}

    ngOnInit(): void {
        this.reservedAssignments = this.data.reservedAssignments;
    }
}
